
export default function CTASection() {
  return (
    <section className="py-20 bg-teal-600">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2
          className="text-4xl md:text-5xl font-bold text-white mb-6"
          style={{ fontFamily: 'Poppins, sans-serif' }}
        >
          Ready to Sell Your Property?
        </h2>
        <p className="text-xl text-white/90 mb-10 leading-relaxed">
          Call us today to sell your real estate! Get a fair cash offer within 24
          hours and close on your timeline.
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <a
            href="tel:+1-915-206-5814"
            className="inline-flex items-center space-x-2 px-8 py-4 bg-white text-teal-600 rounded-lg font-bold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-fill" />
            <span>Call (915) 206-5814</span>
          </a>
          <a
            href="/#contact"
            className="inline-flex items-center space-x-2 px-8 py-4 border-2 border-white text-white rounded-lg font-bold hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-mail-fill" />
            <span>Get Your Offer</span>
          </a>
        </div>
      </div>
    </section>
  );
}
